export default __webpack_public_path__ + "dim-b57417.json";